import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

// import ConstantsList from '../../../common/Constants';

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";
import {
  addPoDetailNumber,
  getPurchaseOrder,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import { currencyFormat } from "../../../../common/Validations";
import Moment from "react-moment";
import configFromEnv from "../../../../services/configuration";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import POInvoiceUploadModal from "./POInvoiceUploadModal";
import ServicePoPrint from "./ServicePoPrint";
import { useReactToPrint } from "react-to-print";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import StatisticsCard from "../../../../Components/Cards/StatisticsCard";
import {
  ChartBarIcon,
  ClockIcon,
  FunnelIcon,
  HandThumbUpIcon,
} from "@heroicons/react/24/solid";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import ItemService from "../../../../services/supplier_appCommonService";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";

const ServicePurchaseOrderList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Service Order");
  let purchase_orderData = useSelector(
    (state) => state?.purchasing?.purchase_order?.service_po?.data,
  ); // User Details from Store
  // Format the price above to USD using the locale, style, and currency.
  // let USDollar = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",
  // });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [totalRows, setTotalRows] = useState(10);
  // const [perPage, setPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const [chatId, setChatId] = useState(null);

  const showUploadInvoice = (purchasingDocumentNr) => {
    let obj = {
      purchasingDocumentNr,
    };
    setModalEditInvoice(true);
    setInvoiceData(obj);
  };
  const hideUploadInvoiceModal = () => {
    setModalEditInvoice(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  // /* Modal Function */
  // const createRFQ = () => {
  //   setModalShow(true);
  // };

  const hideModal = () => {
    setModalShow(false);
  };

  const detailedPage = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE);
  };
  const fetchUsers = async (page) => {
    setLoading(true);
    // const response = await axios.get(`https://reqres.in/api/users?page=${page}&per_page=${perPage}&delay=1`);

    setData(purchase_orderData);
    // setTotalRows(purchase_orderData?.length);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchase_orderData]);

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);
  const fullList = purchase_orderData || [];

  const filteredData = showStats
    ? statusFilter
      ? fullList.filter(
          (item) => item?.statusHeader?.toLowerCase().trim() === statusFilter,
        )
      : fullList
    : fullList;

  const getStatusCounts = (data = []) => {
    let counts = {
      acknowledged: 0,
      inRelease: 0,
    };

    data.forEach((item) => {
      const status = item?.statusHeader?.toLowerCase();
      if (status === "in release") counts.inRelease++;
      if (status === "acknowledged") counts.acknowledged++;
    });

    return counts;
  };

  const statusCount = getStatusCounts(data);

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row.vendorCode)}
              title="Chat With the User"
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Document Type",
      selector: (row) => row.purchasingDocumentCode,
      id: "purchasingDocumentCode",
      sortable: true,
      width: "220px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchasingDocumentType} </p>
        </div>
      ),
    },
    {
      name: "Purchase Type",
      selector: (row) => row.purchaseType || "--",
      id: "purchaseType",
      dropDown: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.purchaseType} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Document",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "100px",
    },

    {
      name: "Upload INV",
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => showUploadInvoice(row.purchasingDocumentNr)}
          >
            Upload
          </button>
        </>
      ),
      width: "120px",
    },

    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Version",
      selector: (row) => row.version || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      id: "statusHeader",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.statusHeader} />
        </>
      ),
      width: "180px",
    },
    {
      name: "Date",
      selector: (row) => row.purchasingDocumentDate,
      sortable: true,
      width: "110px",
      style: {
        textAlign: "right",
      },
      headerStyle: {
        textAlign: "right",
      },
    },
    {
      name: "PO Value",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.purchasingDocumentValue).toFixed(2))}
        </span>
      ),
      selector: (row) => row.purchasingDocumentValue || "--",
      sortable: true,
      width: "120px",
    },
    {
      name: "Currency ",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
        </>
      ),
      selector: (row) => row.currency || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },
    {
      name: "Inco Terms",
      selector: (row) => row.incoTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 ">{row.incoTerms} </p>
        </div>
      ),
    },
    {
      name: "Created Date",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCodeCode} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "PR Number",
      selector: (row) => row.item?.requestNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ",
      cell: (row) => (
        <button className="btnInfo">{row.rfxCollectiveNr || "--"} </button>
      ),
      width: "150px",
    },
    {
      name: "Quotation",
      cell: (row) => (
        <button className="btnInfo">{row.quotationNumber || "--"}</button>
      ),
      width: "150px",
    },
    {
      name: "Quotation Version",
      selector: (row) => row.rfqTechFocalPerson,
      sortable: true,
      width: "160px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Details",
              icon: "bi bi-info-circle",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Net Value",
      cell: (row) => <span>{row.netValue} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    {
      name: "Purchase Req.",
      cell: (row) => <span>{row.requestNumber} </span>,
      width: "220px",
    },
    {
      name: "Purchase Req. Item Nr",
      cell: (row) => <span>{row.prItemNr} </span>,
      width: "220px",
    },

    // {
    //   name: "Item Number",
    //   cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
    //   width: "180px",
    // },
    // {
    //   name: "Material",
    //   cell: (row) => <span>{row.materialCode} </span>,
    //   width: "180px",
    // },
    // {
    //   name: "Material Desc",
    //   cell: (row) => <span>{row.materialDescription} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Material Group",
    //   cell: (row) => <span>{row.materialGroup} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Quantity",
    //   cell: (row) => <span>{row.purchaseQuantity} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "UOM",
    //   cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Delivery Date",
    //   cell: (row) => <span>{row.deliveryDate} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "PR",
    //   cell: (row) => <span>{row.requestNumber || "-"} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "PR Item",
    //   cell: (row) => <span>{row.prItemNr || "-"} </span>,
    //   width: "220px",
    // },
  ];

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "getServicePO",
      module: "PO",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getPurchaseOrder(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  const handleSuccessData = async (data) => {
    // await ItemService.updateDispatchInvoice(data).then((item) => {
    //   // console.log(">> item! title", item);
    //   if (item?.status === 200) {
    //     handleSearchFuncApi();
    //   } else {
    //     console.log(">> Error: Loading getMasterDataSelf");
    //   }
    // });
  };

  //service po print invocie
  const contentRef = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level
  const handlePrint = useReactToPrint({
    contentRef,
    // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  });

  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);

    // Wait for state updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  //toggle chat

  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Service Purchase Order</h2>
            <p className="subText">
              Lists of Service Purchase Order and details
            </p>

            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                fetchFunction={(filters) => {
                  const obj = {
                    queryName: "getServicePO",
                    module: "PO",
                    page: 1,
                    per_page: 200,
                    searchTerm: "",
                    rowFilter: filters.length ? { $and: filters } : {},
                  };

                  return ItemService.getPurchaseOrder(obj);
                }}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}

            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                {/* Header */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <ChartBarIcon
                      className="w-5 h-5"
                      style={{ color: "#3b82f6" }}
                    />
                    <h5 className="m-0">Statistics</h5>
                  </div>

                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                {/* GRID START */}
                <Row className="g-3 stats-row">
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <StatisticsCard
                      label="In Release"
                      count={statusCount.inRelease}
                      icon={
                        <ClockIcon width={16} height={16} color="#d97706" />
                      }
                      color="#ef4444"
                      onClick={() =>
                        setStatusFilter(
                          statusFilter === "in release" ? null : "in release",
                        )
                      }
                    />
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <StatisticsCard
                      label="Acknowledged"
                      count={statusCount.acknowledged}
                      icon={
                        <HandThumbUpIcon
                          width={16}
                          height={16}
                          color="#15803d"
                        />
                      }
                      color="#ef4444"
                      onClick={() =>
                        setStatusFilter(
                          statusFilter === "acknowledged"
                            ? null
                            : "acknowledged",
                        )
                      }
                    />
                  </Col>
                </Row>
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SR</span>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                      <span className="headerTitle">Service PO List</span>
                      <span className="subHeaderTitle">
                        View of Service PO and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      {/* <Col
                        xs={5}
                        md={5}
                        lg={5}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={() => createRFQ()}
                        >
                          <i className="bi bi-plus-lg"></i> Request Supplier for
                          ACK
                        </button>
                      </Col> */}
                      <Col
                        xs={5}
                        md={5}
                        lg={5}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={() => {
                            alert("asd");
                          }}
                        >
                          <i className="bi bi-x-circle"></i> Deletion
                        </button>
                      </Col>

                      <Col xs={2} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 5]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <div style={{ display: "none" }}>
          <ServicePoPrint ref={contentRef} data={getLoadingAdvice} />
        </div>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />

      <POInvoiceUploadModal
        show={getModalEditInvoice}
        onHide={() => hideUploadInvoiceModal()}
        invoiceinfo={invoiceData}
        onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default ServicePurchaseOrderList;
